import { QueryStringHelper } from './QueryStringHelper';

const getDestRefSource = (): string | null => {
  const currentUrl = new URLSearchParams(window.location.search);

  const url = currentUrl.get('redirect_uri')?.toLowerCase();
  
  if (!url) {
    return null;
  }
  
  const destParam = new URL(url).searchParams.get('dest');
  
  if (!destParam) {
    return null;
  }
  
  const decoded = decodeURIComponent(destParam);

  if(!decoded.includes('ref=')) {
    return null;
  }
  
  const refUrl = decoded.split('ref=')[1];
  
  const src = new URL(refUrl).searchParams.get('src');

  if (!src) {
    return null;
  }

  return src;
}

const getRedirectURISource = (): string | null => {
  const currentUrl = new URLSearchParams(window.location.search);

  const url = currentUrl.get('redirect_uri')?.toLowerCase();

  if (!url) {
    return null;
  }

  const destParam = new URL(url).searchParams.get('dest');

  if (!destParam) {
    return null;
  }

  const decoded = decodeURIComponent(destParam);

  const params = new URLSearchParams(decoded);

  const src = params.get('src');

  if (!src) {
    return null;
  }

  return src;
}

const getDestRefCallback = (): string | null => {
  const currentUrl = new URLSearchParams(window.location.search);

  const url = currentUrl.get('redirect_uri')?.toLowerCase();
  
  if (!url) {
    return null;
  }
  
  const destParam = new URL(url).searchParams.get('dest');
  
  if (!destParam) {
    return null;
  }
  
  const decoded = decodeURIComponent(destParam);

  if(!decoded.includes('ref=')) {
    return null;
  }
  
  const refUrl = decoded.split('ref=')[1];
  
  const cbk = new URL(refUrl).searchParams.get('cbk');

  if (!cbk) {
    return null;
  }

  return cbk;
}

const getRedirectURICallback = (): string | null => {
  const currentUrl = new URLSearchParams(window.location.search);

  const url = currentUrl.get('redirect_uri')?.toLowerCase();

  if (!url) {
    return null;
  }

  const destParam = new URL(url).searchParams.get('dest');

  if (!destParam) {
    return null;
  }

  const decoded = decodeURIComponent(destParam);

  const params = new URLSearchParams(decoded);

  const cbk = params.get('cbk');

  if (!cbk) {
    return null;
  }

  return cbk;
}

const createParams = (): string => {
  const params = new URLSearchParams(window.location.search);

  const sourceParam = params.get('src') || getRedirectURISource() || getDestRefSource();

  const searchParams = new URLSearchParams();

  const hasValidSource = !!sourceParam && ['gol', 'smiles', 'SmilesViagens'].includes(sourceParam);

  const hasCulture = localStorage.getItem('@auth0_culture') as string;

  const hasCallback = params.get('cbk') || getRedirectURICallback() || getDestRefCallback();

  if (hasValidSource) {
    searchParams.append('src', sourceParam);
  }

  if (hasCulture) {
    searchParams.append('culture', hasCulture);
  }

  if(hasCallback) {
    searchParams.append('cbk', hasCallback);
  }

  if (hasCulture || hasValidSource) {
    return `?${searchParams.toString()}`;
  }

  return '';
}

interface IGetLinkOptions {
  skipQueryParams: boolean
}

const getLink = (link: string, params?: IGetLinkOptions): string => {
  let redirectParams = '';

  if (!params?.skipQueryParams) {
    redirectParams = createParams();
  }

  if (QueryStringHelper.isApp) {
    let suffix = '';
    if (window.env.indexOf('portal-uat') === 0) {
      suffix = '.hml';
    } else if (window.env.indexOf('portal-dev') === 0) {
      suffix = '.dev';
    }

    return `com.br.smiles${suffix}://${link}${redirectParams}`;
  }

  return `https://${window.env}.smiles.com.br/${link}${redirectParams}`;
};

export { getLink, getRedirectURISource, getDestRefSource };
